import axios from 'axios';
import hexSha1 from 'hex-sha1';
import { deviceDetect } from 'react-device-detect';
import { useStorage } from '../hooks/use-storage';

function useAccountAPI() {
  const { userRef, menuIdRef, spot, menuSlug, languageRef } = useStorage();

  function accountSignupFromRemote(name) {
    const url = `/vbeta2/account/signup`;

    const hashInfo = {
      deviceInfo: deviceDetect(),
      spotId: spot?.id,
      slug: menuSlug,
      name,
    };

    // hexSha1(JSON.stringify());

    return axios({
      url,
      method: 'post',
      data: {
        name,
        hash: hexSha1(JSON.stringify(hashInfo)),
      },
      headers: {
        'Content-Type': 'application/json',
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  function googleSigninFromRemote(accessToken) {
    const url = `/vbeta2/account/signin/google`;

    return axios({
      url,
      method: 'post',
      data: {
        access_token: accessToken,
      },
      headers: {
        'Content-Type': 'application/json',
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  function appleSigninFromRemote(data) {
    const url = `/vbeta2/account/signin/apple`;

    return axios({
      url,
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json',
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  function checkCurrentAccountFromRemote() {
    const url = `/vbeta2/account/check`;

    return axios({
      url,
      method: 'post',
      data: {},
      headers: {
        Authorization: `Bearer ${userRef?.current?.token}`,
        'Menu-Id': menuIdRef.current,
        'Content-Type': 'application/json',
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  function updateProfileNameFromRemote(name) {
    const url = `/vbeta2/account/profile/name`;

    return axios({
      url,
      method: 'put',
      data: name,
      headers: {
        Authorization: `Bearer ${userRef?.current?.token}`,
        'Menu-Id': menuIdRef.current,
        'Content-Type': 'text/plain',
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'text',
    });
  }

  return {
    accountSignupFromRemote,
    // getGoogleOauthClientIdFromRemote,
    // getAppleOauthClientIdFromRemote,
    // getSigninConfigFromRemote,
    googleSigninFromRemote,
    appleSigninFromRemote,
    checkCurrentAccountFromRemote,
    updateProfileNameFromRemote,
  };
}

export { useAccountAPI };
